export enum eClientContactActionType {
  Activate = 'Activate',
  Deactivate = 'Deactivate',
  Invite = 'Invite',
  ResetPassword = 'Reset Password',
  ReinviteUser = 'Reinvite User',
}
